<template>
  <div class="relative">
    <!-- 히어로 섹션 -->
    <section class="relative bg-gradient-to-br from-primary-600 to-primary-800 text-white">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h1 class="text-4xl lg:text-5xl font-bold leading-tight mb-6">
              새로운 좌석 예약의
              <span class="text-primary-300">시작</span>
            </h1>
            <p class="text-lg lg:text-xl text-primary-100 mb-8 leading-relaxed">
              언제 어디서나 간편하게 좌석 배치를 만들고 예약을 시작하세요.<br>
              실시간 현황 확인과 안전한 예약 시스템을 제공합니다.
            </p>
            <div class="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <RouteButton
                route="/posts"
                text="예약 가능한 장소 보기"
                type="outline"
                size="lg"
                textSize="sm"
                textColorClass="text-primary-600"
                fontWeight="bold"
              />
              <RouteButton
                  v-if="!isAuthenticated"
                  route="/posts"
                  text="무료로 시작하기"
                  type="outline"
                  size="lg"
                  textSize="sm"
                  textColorClass="text-gray-700"
                  hoverClass="text-primary-600"
                  fontWeight="medium"
              />
            </div>
          </div>
          <div class="relative">
            <div class="bg-white bg-opacity-10 rounded-2xl p-8 backdrop-blur-sm">
              <!-- 샘플 좌석 배치 미리보기 -->
              <div class="space-y-3">
                <div class="flex justify-center space-x-2">
                  <div class="seat seat-available" v-on:click="toggleSeat(1)" id="seat-1">1</div>
                  <div class="seat seat-available" v-on:click="toggleSeat(2)" id="seat-2">2</div>
                  <div class="seat seat-reserved">3</div>
                  <div class="seat seat-available" v-on:click="toggleSeat(4)" id="seat-4">4</div>
                </div>
                <div class="flex justify-center space-x-2">
                  <div class="seat seat-reserved">5</div>
                  <div class="seat seat-available" v-on:click="toggleSeat(6)" id="seat-6">6</div>
                  <div class="seat seat-available" v-on:click="toggleSeat(7)" id="seat-7">7</div>
                  <div class="seat seat-reserved">8</div>
                </div>
                <div class="flex justify-center space-x-2">
                  <div class="seat seat-available" v-on:click="toggleSeat(9)" id="seat-9">9</div>
                  <div class="seat seat-disabled"></div>
                  <div class="seat seat-disabled"></div>
                  <div class="seat seat-available" v-on:click="toggleSeat(10)" id="seat-10">10</div>
                </div>
              </div>
              <div class="mt-6 text-center">
                <p class="text-white text-sm opacity-90">실시간 좌석 현황</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 배경 패턴 -->
      <div class="absolute inset-0 opacity-10 pointer-events-none">
        <div class="absolute inset-0 bg-repeat" style="background-image: url('data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')"></div>
      </div>
    </section>

    <!-- 주요 기능 섹션 -->
    <section class="py-16 lg:py-24 bg-white">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-16">
          <h2 class="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            왜 Seatisfy인가요?
          </h2>
          <p class="text-xl text-gray-600 max-w-3xl mx-auto">
            사용자 친화적인 인터페이스와 강력한 기능으로 완벽한 예약 경험을 제공합니다.
          </p>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div
            v-for="feature in features"
            :key="feature.title"
            class="text-center group"
          >
            <div class="inline-flex items-center justify-center w-16 h-16 bg-primary-100 text-primary-600 rounded-2xl mb-6 group-hover:bg-primary-200 transition-colors">
              <component :is="feature.icon" class="w-8 h-8" />
            </div>
            <h3 class="text-xl font-semibold text-gray-900 mb-4">
              {{ feature.title }}
            </h3>
            <p class="text-gray-600">
              {{ feature.description }}
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- 최근 게시글 섹션 -->
    <section class="py-16 lg:py-24 bg-gray-50">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between items-center mb-12">
          <div>
            <h2 class="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              최근 예약 가능한 장소
            </h2>
            <p class="text-xl text-gray-600">
              지금 바로 예약할 수 있는 인기 장소들을 확인해보세요.
            </p>
          </div>
<!--          <RouterLink-->
<!--            to="/posts"-->
<!--            class="btn btn-primary btn-md hidden sm:inline-flex"-->
<!--          >-->
<!--            전체 보기-->
<!--          </RouterLink>-->
          <RouteButton
            route="/posts"
            text="전체 보기 ➔"
            type="outline"
            add-class-option="hidden sm:inline-flex"
          />
        </div>

        <!-- 최근 게시글 목록 -->
        <div v-if="recentPosts?.length > 0" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <PostCard
            v-for="post in recentPosts"
            :key="post.id"
            :post="post"
            :seatLayoutInfo="getSeatLayoutInfoByPost(post)"
            :reserved-seat-numbers="reservedSeatNumbersByPost[post.id]"
            class="hover:shadow-lg transition-shadow"
          />
        </div>

        <div v-else-if="isLoading" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <PostCardSkeleton v-for="n in 6" :key="n" />
        </div>

        <div v-else class="text-center py-12">
          <p class="text-gray-500 mb-4">아직 등록된 게시글이 없습니다.</p>
          <RouteButton
            route="/posts/create"
            text="첫 번째 게시글 작성하기"
          />
        </div>

        <div class="text-center mt-8 sm:hidden">
          <RouteButton
            route="/posts"
            text="전체 보기"
          />
        </div>
      </div>
    </section>

    <!-- CTA 섹션 -->
    <section class="py-16 lg:py-24 bg-primary-600 text-white">
      <div class="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
        <h2 class="text-3xl lg:text-4xl font-bold mb-6">
          지금 바로 시작해보세요!
        </h2>
        <p class="text-xl text-primary-100 mb-8">
          무료 회원가입으로 Seatisfy의 모든 기능을 이용할 수 있습니다.
        </p>
        <div v-if="!isAuthenticated" class="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
          <RouteButton
              route="/register"
              type="outline"
              size="lg"
              font-weight="bold"
              text="무료 회원가입"
              text-size="md"
              text-color-class="text-primary-600"
          />
          <RouteButton
              route="/posts"
              type="outline"
              size="lg"
              font-weight="medium"
              text="둘러보기"
              text-size="md"
              hover-class="text-primary-600"
          />
        </div>
        <div v-else>
          <RouteButton
              route="/posts/create"
              type="outline"
              size="lg"
              font-weight="bold"
              text="새 게시글 작성하기"
              text-size="md"
              text-color-class="text-primary-600"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import {
  ClockIcon,
  ShieldCheckIcon,
  DevicePhoneMobileIcon,
  UserGroupIcon,
  MapPinIcon,
  BellAlertIcon
} from '@heroicons/vue/24/outline'
import { useAuthStore } from '@/stores/auth'
import {postApi, reservationApi} from '@/services/api'
import type {Post, SeatLayoutInfo} from '@/types'
import PostCard from '@/components/PostCard.vue'
import PostCardSkeleton from '@/components/PostCardSkeleton.vue'
import RouteButton from "@/components/common/Button/RouteButton.vue";
import {deserializeSeatStatus} from "@/utils";

const authStore = useAuthStore()
const isAuthenticated = computed(() => authStore.isAuthenticated)

const recentPosts = ref<Post[]>([])
const reservedSeatNumbersByPost = ref<Record<number, number[]>>({})
const isLoading = ref(true)

// 주요 기능들
const features = [
  {
    title: '실시간 현황',
    description: '좌석 예약 현황을 실시간으로 확인하고 빠르게 예약하세요.',
    icon: ClockIcon
  },
  {
    title: '안전한 보안',
    description: '개인정보와 예약 정보는 최신 보안 기술로 안전하게 보호됩니다.',
    icon: ShieldCheckIcon
  },
  {
    title: '모바일 최적화',
    description: '어떤 기기에서든 편리하게 이용할 수 있는 반응형 디자인입니다.',
    icon: DevicePhoneMobileIcon
  },
  {
    title: '사용자 친화적',
    description: '직관적인 인터페이스로 누구나 쉽게 이용할 수 있습니다.',
    icon: UserGroupIcon
  },
  {
    title: '다양한 장소',
    description: '스터디룸, 코워킹스페이스, 회의실 등 다양한 공간을 지원합니다.',
    icon: MapPinIcon
  },
  {
    title: '알림 기능',
    description: '예약 확인, 변경사항을 이메일로 안내해드립니다.',
    icon: BellAlertIcon
  }
]

const toggleSeat = (seatNumber: number) => {
  const idList = [1,2,4,6,7,9,10]
  idList.forEach((item) => {
    const id = `seat-${item}`;
    const el = document.getElementById(id);
    el?.classList.remove("seat-selected");
    el?.classList.add("seat-available");
  })

  const id = `seat-${seatNumber}`;
  const el = document.getElementById(id);
  if (el) {
    el.classList.remove("seat-available");
    el.classList.add("seat-selected");
  }
};

const getSeatLayoutInfoByPost = (post: Post) => {
  const seatStatus: number[][] = deserializeSeatStatus(post.seatLayout)
  const rows: number = seatStatus.length
  const seatsPerRow: number = seatStatus[0]?.length
  let totalSeats: number = 0;
  seatStatus.forEach(x => x.forEach(y => { if (y == 1) { totalSeats++ } }))

  const seatLayoutInfo: SeatLayoutInfo = {
    rows,
    seatsPerRow,
    totalSeats,
    seatStatus
  }

  return seatLayoutInfo
}

// 최근 게시글 로드
const loadRecentPosts = async () => {
  try {
    isLoading.value = true
    const response = await postApi.getPosts({ size: 3 })
    recentPosts.value = response.content
    if (recentPosts.value.length > 0) {
      try {
        const seatStatusResponse = await reservationApi.getPostSeatStatuses(
          recentPosts.value.map(post => post.id)
        )
        const seatMap: Record<number, number[]> = {}
        seatStatusResponse.data.forEach(status => {
          seatMap[status.postId] = status.reservedSeatNumbers || []
        })
        reservedSeatNumbersByPost.value = seatMap
      } catch (error) {
        console.error('Failed to load seat status:', error)
        reservedSeatNumbersByPost.value = {}
      }
    } else {
      reservedSeatNumbersByPost.value = {}
    }
  } catch (error) {
    console.error('Failed to load recent posts:', error)
  } finally {
    isLoading.value = false
  }
}

onMounted(() => {
  loadRecentPosts()
})
</script>

<style scoped>
.seat {
  width: 2rem;
  height: 2rem;
  border-radius: 0.375rem;
  border: 2px solid;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 500;
  transition: all 0.2s;
}

.seat-available {
  @apply bg-green-100 border-green-300 text-green-800 hover:bg-green-200;
}

.seat-reserved {
  @apply bg-red-100 border-red-300 text-red-800;
}

.seat-selected {
  @apply bg-blue-100 border-blue-300 text-blue-800;
}

.seat-disabled {
  @apply bg-gray-100 border-gray-300 text-gray-800;
}
</style>
